import {Logo} from "@mytour/ui/logo";
import {NavLink} from "react-router";
import {NavbarBrand} from "reactstrap";
import {useModeration} from "../authentication/authenticationQueries";

export function Brand() {
  const {isModeration} = useModeration();

  return (
    <NavbarBrand tag={NavLink} to="/" className="brand-logo">
      <Logo />
      {isModeration && (
        <span
          className="navbar-version"
          style={{
            position: "absolute",
            color: "red",
            zIndex: 2000,
            marginLeft: "95px",
            top: "36px",
          }}
        >
          Modération
        </span>
      )}
    </NavbarBrand>
  );
}
